export default {
    SET_CLASSIFIEDS(state, classifieds) {
        state.classifieds = classifieds.items
        state.totalPages = classifieds.total_pages
    },
    ADD_CLASSIFIED(state, classified) {
        state.classifieds.unshift(classified)
    },
    DELETE_CLASSIFIED(state, classifiedId) {
        const ItemIndex = state.classifieds.findIndex((u) => u.id === classifiedId)
        state.classifieds.splice(ItemIndex, 1)
    },
    SET_CLASSIFIED_INFOS(state, classified) {
        state.classifiedInfos = classified
    }
}
